import { render, staticRenderFns } from "./CustomerIndividualExport.vue?vue&type=template&id=645724fc&scoped=true"
import script from "./CustomerIndividualExport.vue?vue&type=script&lang=js"
export * from "./CustomerIndividualExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645724fc",
  null
  
)

export default component.exports